import fetch from '../../common/services/fetch';
import { IHttpMethod, ServicesURL } from '../ts/enums/fetch-enums';

interface IUseAppAuthData {
  readonly register: () => Promise<void>;
  readonly remove: () => Promise<void>;
}

export const useAppAuthData = (): IUseAppAuthData => {
  async function register() {
    try {
      const deviceIdentifier = localStorage.getItem('appAuthData-DeviceIdentifier');
      const pushOS = localStorage.getItem('PushTokenOS') ?? 'unknown';
      const pushPermissionGranted = localStorage.getItem('PushTokenPermissionGranted') == 'true';

      if (!deviceIdentifier) return;

      await fetch({
        method: IHttpMethod.POST,
        path: 'app-auth-data/register', 
        service: ServicesURL.CRYPTOCRONTROL,
        data: {
          deviceIdentifier: deviceIdentifier,
          cookies: (window as any)?.getAllCookies(),
          pushOS: pushOS,
          pushPermissionGranted: pushPermissionGranted,
        },
      });

      localStorage.setItem('appAuthData-Registered', 'true');
    } catch (error) {
      //console.error('Failed to register app auth data', error);
    }
  }

  async function remove() {
    try {
      if (!localStorage.getItem('appAuthData-Registered')) return;

      const deviceIdentifier = localStorage.getItem('appAuthData-DeviceIdentifier');

      if (!deviceIdentifier) return;

      await fetch({
        method: IHttpMethod.POST,
        path: 'app-auth-data/remove', 
        service: ServicesURL.CRYPTOCRONTROL,
        data: {
          deviceIdentifier: deviceIdentifier,
        },
      });

      localStorage.removeItem('appAuthData-Registered');
    } catch (error) {
      //console.error('Failed to remove app auth data', error);
    }
  }

  return {
    register,
    remove
  };
};
